import { describeStaffFailure, neutralForbidden } from "../../failure-words";
import type { CommandFailure } from "../../ui/command-dialog";

// How "New request" tells a staff member that the server refused or did not answer. No customer text, no id and no reason goes into a message
// (the API sends none). A refusal for access, a customer that is missing and a customer that was erased read the same: the form never says why.

export function describeCreateFailure(error: unknown): CommandFailure {
  const failure = describeStaffFailure(error, {
    forbidden: neutralForbidden("requests for this customer"),
    conflict:
      "The server could not create the request because the same action is still running or was sent with other details. Nothing was changed by this attempt. Close this window and try again.",
    invalid:
      "The server did not accept these details. Check the fields, for example the date and the time zone. Nothing was created.",
  });
  return {
    message: failure.message,
    retryable: failure.retryable,
    // The form always stays open, so the person keeps what they typed: they fix a refused field, or change the customer after a refusal of
    // access. A send that is not a retry of a lost answer is another command and gets another key.
    keepForm: !failure.retryable,
    kind: failure.kind,
    tone: failure.kind === "conflict" ? "conflict" : "error",
  };
}
